<!-- Botón flotante -->
<div class="fab-item">
    <button (click)="exportar()" pTooltip="Exportar gráficos" [tooltipPosition]="'left'">
        <i class="pi pi-file-export"></i>
    </button>
</div>